import axiosInstance from '../config/axios';
import { standardizeError } from '../utils/errorHandler';
import { api } from '../config/api';

const getAdminConfig = async () => {
  try {
    const res = await axiosInstance.get(api.adminConfig);
    return res.data;
  } catch (err) {
    throw standardizeError(err);
  }
};
const adminConfigApi = {
  getAdminConfig,
};

export default adminConfigApi;
